import { h } from 'preact'

export default function({ link }) {
  return (
    <footer className="conversion-step__footer">
      <a className="conversion-step__privacy-policy" href={link}>Política de privacidade.</a>
    </footer>
  )
}
